/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './about.stache';
import dtm from 'scripts/services/dtm';
import 'swiper';
import DomEventsManager from 'scripts/dom-events-manager';
import urlUtil from 'scripts/utils/url';
import can from 'can';
import appContext from 'scripts/app-context';

Component.extend({
    tag: 'history-experience-about',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            isPreviewClicked: {
                type: 'boolean',
                value: false,
            },
        },
    },
    events: {
        '.s-preview-image click'(element) {
            const videoName = element.data('video-name');

            dtm.trackHistoryVideoLauch(videoName, 'History About');
            this.viewModel.attr('isPreviewClicked', true);
        },
    },
});
